import * as yup from 'yup';
import { i18n } from '@localization';

var getAddNewOrganizationSchema = function getAddNewOrganizationSchema(error, phoneError) {
  return yup.object().shape({
    name: yup.string().required('').test('name', '', function (value, ctx) {
      if (error) {
        return ctx.createError({
          message: error
        });
      }

      return true;
    }),
    email: yup.string().email(i18n.t('forms.validation.email')),
    phone_number: yup.string().nullable().notRequired().when('phone_number', {
      is: function is(value) {
        return value === null || value === void 0 ? void 0 : value.length;
      },
      then: function then(rule) {
        return rule.min(2);
      }
    }).test('phone_number', '', function (value, ctx) {
      if (phoneError) {
        return ctx.createError({
          message: phoneError
        });
      }

      return true;
    }),
    contact_name: yup.string()
  }, [['phone_number', 'phone_number']]);
};

export { getAddNewOrganizationSchema };